import React from 'react';
import { Shape } from 'cards/components/CardListing/types';
import ProvisionalSelectBtnImage from '../../ProvisionalComponents/ProvisionalSelectBtnImage';
import { ShapeMenuContainer } from './ShapeMenu.style';

interface ShapeMenuProps {
  activeValue: string[];
  updateFilter: (filter: 'silhouettes', value: string[]) => void;
  optionList: Shape[];
}

export const ShapeMenu: React.FC<ShapeMenuProps> = ({ activeValue, optionList, updateFilter }) => (
  <ShapeMenuContainer>
    {optionList.map(key => (
      <ProvisionalSelectBtnImage
        key={key.label}
        label={key.label}
        icon={key.icon}
        isActive={activeValue?.includes(key.value)}
        onClick={() =>
          updateFilter('silhouettes', activeValue.includes(key.value) ? [] : [key.value])
        }
      />
    ))}
  </ShapeMenuContainer>
);
